module.exports = __webpack_public_path__ + "img/DCS_0011-1.79180c52.jpg";